import React from "react";
import "./logolayout.css";

import Progress from "../progress/progress";
import { Link } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import Button from "../button/button";
export default function LogoLayout(props: {
  progress?: number;
  hideBack?: boolean;
  params?: any;
  children?: any;
  onSubmit?: any;
  submitTitle?: string;
  showLogo?: boolean;
  showMobileBack?: boolean;
  renderBeforeSubmit?: any;
  renderAfterSubmit?: any;
  onMobileBack?: any;
  submitDisabled?: boolean;
  hideTitle?: boolean;
}) {
  const canGoBack = window.history.state.idx !== 0;
  const methods = useForm({ mode: "onSubmit" });
  return (
    <div className="row logolayout">
      <div className="col-md-6 leftbar">
        <div className="myimage">
          {/* <img className="im1" src={"/images/ele3.png"} alt="" /> */}
          <div className="logo">
            <img src={"/images/kovalogo.svg"} alt="logo kova" />
          </div>
        </div>
      </div>
      <div className="col formsection d-flex align-items-center justify-content-center ">
        <div className="col">
          <div className="section2">
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  marginBottom: canGoBack && !props.hideBack ? 20 : 30,
                  marginTop: canGoBack && !props.hideBack ? 0 : 12,
                }}
              >
                {canGoBack && !props.hideBack && (
                  <div>
                    <Link to={-1 as any}>
                      <div className="backcontainer">
                        <img className="backimg" src={"/images/left-arrow.svg"} alt="" />
                      </div>
                    </Link>
                  </div>
                )}
                {!props.hideTitle && (
                  <span className="current" style={{ left: "44%", position: "absolute" }}>
                    {" "}
                    Inscription
                  </span>
                )}
              </div>
              {props.showMobileBack && (
                <div onClick={props.onMobileBack}>
                  <div className="backcontainer">
                    <img className="backimg" src={"/images/left-arrow.svg"} alt="" />
                    <h2 className="backtext">Back</h2>
                  </div>
                </div>
              )}
              {props.progress && <Progress progress={props.progress} />}
            </div>
            {props.showLogo && (
              <div className="logosmall">
                <img src={"/images/kovalogo.svg"} alt="logo kova" />
              </div>
            )}
            <FormProvider {...methods}>
              {props.children}
              {props.onSubmit ? (
                <div
                  style={{
                    marginBottom: props?.params?.fromMobileApp ? 80 : 0,
                  }}
                  className="bottom-container"
                >
                  {props.renderBeforeSubmit ? props.renderBeforeSubmit() : null}
                  <Button
                    onClick={methods.handleSubmit(props?.onSubmit)}
                    className="btn-primary"
                    disabled={props.submitDisabled}
                    title={props.submitTitle || "Next"}
                  />
                  {props.renderAfterSubmit ? props.renderAfterSubmit() : null}
                </div>
              ) : null}
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
}
